<template>
    <InputDropdownCheckboxes
        translationkey="general.choose-racegroups"
        v-model="filteredRaceGroups"
        :data="raceGroups"
        :hasSelectAllCheckbox="true"
        :icon="featureIcons.GROUPS"
    />
</template>
<script setup lang="ts">
import { InputDropdownCheckboxes } from '@/components';
import { featureIcons } from '@/components/Menu/featureicons';
import { useEventCommonStore } from '@/stores';
import type { RacesGroupsCategoriesMap } from '@/utilities/RacesGroupsCategoriesMap';
import { computed } from 'vue';

const props = defineProps<{
    /**
     * A {@see RacesGroupsCategoriesMap} that can provide the possible racegroup choices based on the raceID
     */
    racesGroupsCategoriesMap: RacesGroupsCategoriesMap;

    /**
     * The currently selected race (if any)
     */
    raceID: number | null;
}>();
const filteredRaceGroups = defineModel<number[]>({ required: true });

const raceGroups = computed(() => {
    const groupIDs = props.racesGroupsCategoriesMap.GetGroupIDs(props.raceID);

    return Array.from(useEventCommonStore().GroupsAsSelectLine.values()).filter((g) => groupIDs.includes(g.value as number));
});
</script>
